import { getLocale } from "../runtime";

const sv_searchresultfor = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Visar resultat för`
};

const searchresultfor = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_searchresultfor(inputs)
	return "searchResultFor";
};

export { searchresultfor as "searchResultFor" };